import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=c73f64c8&scoped=true&"
import script from "./ForgotPassword.vue?vue&type=script&lang=ts&"
export * from "./ForgotPassword.vue?vue&type=script&lang=ts&"
import style0 from "./Registration.scss?vue&type=style&index=0&id=c73f64c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c73f64c8",
  null
  
)

export default component.exports